<template>
  <div class="container-fluid">
    <div class="row" id="app">
      <!-- Inputs Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <TopbarNav />
        <hr/>
            <!-- Section 1: Climatic Data -->
                <div class="row">
                  <div class="col-6">
                    <input type="radio" v-model="climate_method" value="user">By User
                  </div>
                  <div class="col-6">
                    <input type="radio" v-model="climate_method" value="location">By Location
                  </div>
                </div>
                <hr/>
                <div>
                  <!-- Province -->
                  <div class="row" v-if="climate_method === 'location'">
                    <div class="col-6">Province</div>
                    <div class="col-6">
                      <select name="province" v-model="province">
                      <option value="Alberta">Alberta</option>
                      <option value="British Columbia">British Columbia</option>
                      <option value="Manitoba">Manitoba</option>
                      <option value="New Brunswick">New Brunswick</option>
                      <option value="Newfoundland">
                        Newfoundland
                      </option>
                      <option value="Northwest Territories">Northwest Territories</option>
                      <option value="Nova Scotia">Nova Scotia</option>
                      <option value="Ontario">Ontario</option>
                      <option value="Prince Edward Island">Prince Edward Island</option>
                      <option value="Quebec">Quebec</option>
                      <option value="Saskatchewan">Saskatchewan</option>
                      <option value="Yukon">Yukon</option>
                    </select>
                    </div>
                    
                  </div>
                  <!-- City -->
                  <div class="row" v-if="climate_method === 'location' && province">
                    <div class="col-6">City</div>
                    <div class="col-6">
                      <select name="city" v-model="city" class="city-select">
                        <option v-for="(city, index) in cities" :key="index" :value="city.city">{{ city.city }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- Ground Snow Load, Ss -->
                <div class="row" v-if="climate_method === 'user'">
                  <div class="col-6">Ground Snow Load, Ss</div>
                  <div class="col-6">
                    <input
                      type="number"
                      name="Ss"
                      v-model="Ss_user"
                      /><span>kPa</span>  
                    </div>
                  </div>
                  <!-- Rain Load, Sr -->
                  <div class="row" v-if="climate_method === 'user'">
                    <div class="col-6">Rain Load, Sr</div>
                    <div class="col-6">          
                      <input
                        type="number"
                        name="Sr"
                        v-model="Sr_user"
                      />kPa
                    </div>
                    <p class="fst-italic comment">Rain load at any location on a roof need not to be taken greater than the load due to snow, i.e., S<sub>r</sub>≤S<sub>s</sub>(C<sub>b</sub>C<sub>w</sub>C<sub>s</sub>C<sub>a</sub>)</p>
                </div>

            <!-- Section 2: Factors -->
              <div>
                <!-- Is -->
                <div class="row">
                  <div class="col-6">
                    <label for="Is">Importance Category:</label>
                  </div>
                  <div class="col-6">
                    <select name="Is_category" v-model="Is_category">
                      <option value="0">Low</option>
                      <option value="1">Normal</option>
                      <option value="2">High</option>
                      <option value="3">Post Disaster</option>
                    </select>
                  </div>
                </div>
                <hr/>
                <!-- Cw -->
                <div class="row">
                  <div class="col-6">
                    <label for="Cw">Wind Exposure Factor, Cw:</label>
                  </div>
                  <div class="col-6">
                    <div><input type="radio" v-model="Cw"  value="1">1.00</div>
                      <!-- For low and normal importance category, Cw can be either 0.75 or 0.50 -->
                    <div><input type="radio" v-if="Is_category<2" v-model="Cw" name="some-radios" value="0.75">0.75 <span class="fst-italic">Rural areas</span></div>
                    <div><input type="radio" v-if="Is_category<2" v-model="Cw" name="some-radios" value="0.50">0.50 <span class="fst-italic">Exposed areas north of treeline</span></div>
                  </div>
                </div>
                <div class="row" v-if="Cw != 1">
                  <div class="fst-italic alert alert-warning">
                    <p>
                      To use a C<sub>w</sub> of lower than 1, following conditions should all be true:
                    </p>
                    <ul>
                      <li>The building is exposed on all sides to wind over open terrain as defined in Clause 4.1.7.3.(5)(a), and is expected to remain so during its life.</li>
                      <li>The area of roof under consideration is exposed to the wind on all sides with no significant obstructions on the roof, such as parapet walls, within a distance of at least 10 times the difference between the height of the obstruction and
                        <math xmlns="http://www.w3.org/1998/Math/MathML">
                          <mi>C</mi><sub><mi>b</mi></sub>
                          <mi>C</mi><sub><mi>w</mi></sub>
                          <mi>S</mi><sub><mi>s</mi></sub>
                          <mo>/</mo>
                          <mi>&gamma;</mi>
                        </math> meters, where &gamma;
                        is the specific weight of snow on roofs as specified in Article 4.1.6.13.</li>
                      <li>The loading does not involve the accumulation of snow due to drifting from adjacent surfaces.</li>
                      <li>The buildings are not in the High or Post-disaster Importance Categories described in NBC Table 4.1.2.1.</li>
                    </ul>
                  </div>
                </div>
                <hr />
                <!-- Cb -->
                <div class="row">
                  <!-- Cb Method -->
                  <div class="col-6">
                    <p>C<sub>b</sub> Calculation Method</p>
                  </div>
                    <div class="col-6">
                      <div><input type="radio" v-model="Cb_method" value="user">By User</div>
                      <div><input type="radio" v-model="Cb_method" value="plan">By roof plan dimensions</div>
                    </div>
                </div>
                <!-- Cb defined by user -->
                <div class="row" v-if="Cb_method === 'user'">
                  <div class="col-6">
                    <label for="Cb">Basic Roof Snow Load Factor, Cb:</label>
                  </div>
                  <div class="col-6" >
                    <input type="text" name="Cb" v-model="Cb_user" />
                  </div>
                </div>
                <!-- Roof Plan Dimentsions -->
                <div v-else>
                   <div class="row">
                     <div class="col-6">
                       <label for="l">Longer dimension, l:</label>
                     </div>
                     <div class="col-6">
                       <input type="number" name="l" v-model="l" />m
                     </div>
                   </div>
                   <div class="row">
                     <div class="col-6">
                       <label for="w">Shorter dimension, w:</label>
                     </div>
                     <div class="col-6">
                       <input type="number" name="w" v-model="w" :max="l"/>m
                     </div>
                     <div class="alert alert-danger" v-if="w > l">w cannot be greater than l</div>
                   </div>
                  </div>
                </div>
                <hr />

            <!-- Section 3: Roof Pitch -->
              <!-- Cs Method -->
              <div class="row">
                <div class="col-6">
                  <p>C<sub>s</sub> Calculation Method</p>
                </div>
                <div class="col-6">
                  <div><input type="radio" v-model="Cs_method" value="user">By User</div>
                  <div><input type="radio" v-model="Cs_method" value="pitch">By roof pitch</div>
                </div>
              </div>
              <div class="row" v-if="Cs_method === 'user'">
                <div class="col-6">
                  <label for="Cs">Slope Factor, Cs:</label>
                </div>
                <div class="col-6" >
                  <input type="text" name="Cs" v-model="Cs_user" />
                </div>
              </div>
              <div v-else>
                <!-- Pitch -->
                <div class="row">
                  <div class="col-6">
                    <label for="pitch">Pitch:</label>
                  </div>
                  <div class="col-6">
                    <input type="text" name="pitch" v-model="pitch" />/12
                  </div>
                </div>
                <!-- Slippery -->
                <div class="row">
                  <div class="col-6">
                    <label for="slippery">Unobstructed slippery roof?</label>
                  </div>
                  <div class="col-6">
                    <select name="slippery" v-model="slippery">
                      <option value=true>Yes</option>
                      <option value=false>No</option>
                    </select>
                  </div>
                </div>
              </div>
              <hr />
            <!-- Section 4: Accumulation Factor -->
            <!-- Ca Method -->
            <div class="row">
              <div class="col-6">
                <p>C<sub>a</sub> Calculation Method</p>
              </div>
              <div class="col-6">
                <div><input type="radio" v-model="Ca_method" value="user">By User</div>
                <div><input type="radio" v-model="Ca_method" value="multi_level_roofs">Multi-level Roofs 4.1.6.5.</div>
                <div><input type="radio" v-model="Ca_method" value="roof_projection" disabled>Vertical Roof Projection 4.1.6.7.</div>
                <div><input type="radio" v-model="Ca_method" value="gable_roofs" disabled>Gable Roofs 4.1.6.9.</div>
                <div><input type="radio" v-model="Ca_method" value="arch_curved_roofs" disabled>Arch or Curved Roofs 4.1.6.10.</div>
                <div><input type="radio" v-model="Ca_method" value="domes" disabled>Domes 4.1.6.10.</div>
                <div><input type="radio" v-model="Ca_method" value="valleys" disabled>Valleys in Curved or Sloped Roofs 4.1.6.12.</div>
              </div>
            </div>
            <div class="row" v-if="Ca_method === 'user'">
              <div class="col-6">
                <label for="Ca">Accumulation Factor, Ca:</label>
              </div>
              <div class="col-6">
                <input type="text" name="Ca" v-model="Ca_user" />
              </div>
            </div>
            <!-- Geometry inputs for Ca calculation -->
            <div v-if="Ca_method === 'multi_level_roofs'">
              <!-- Height Difference -->
              <div class="row">
                <div class="col-6">
                  <label for="h">Height difference, h:</label>
                </div>
                <div class="col-6">
                  <input type="number" name="h" v-model="h" />m
                </div>
                <p class="fst-italic comment">Difference in elevation between lower roof surface and top of parapet of upper roof</p>
                <div class="col-6">
                </div>
              </div>
                
              <!-- Horizontal Gap -->
              <div class="row">
                <div class="col-6">
                  <label for="h">Horizontal Gap, a:</label>
                </div>
                <div class="col-6">
                  <input type="number" name="a" v-model="a" />m
                </div>
                <p class="fst-italic comment">If horizontal gap between higher and lower roofs is greater than 5m, snow drift can be ignored (4.1.6.6).</p>
                <div class="col-6">
                </div>
              </div>
              <!-- Bootstrap Vue Tabs for Cases -->
              <b-tabs content-class="mt-2">
                <!-- Case I Tab -->
                <b-tab title="Case I" active>
                  <div class="row">
                    <div class="col-6">
                      <table class="table table-sm table-bordered">
                        <tbody>
                        <tr>
                          <td>w<sub>s</sub> (m)</td>
                          <td><input type="number" v-model="cases[0].ws" /></td>
                        </tr>
                        <tr><td colspan="2"><p class="fst-italic comment">Shorter dimension of the upper roof</p></td></tr>
                        <tr>
                          <td>l<sub>s</sub> (m)</td>
                          <td><input type="number" v-model="cases[0].ls" /></td>
                        </tr>
                        <tr><td colspan="2"><p class="fst-italic comment">Longer dimension of the upper roof</p></td></tr>
                        <tr>
                          <td>h<sub>p</sub> (m)</td>
                          <td><input type="number" v-model="cases[0].hp" /></td>
                        </tr>
                        <tr><td colspan="2"><p class="fst-italic comment">Parapet height of the upper roof</p></td></tr>
                        <tr>
                          <td>C<sub>ws</sub></td>
                          <td>
                            <select v-model="cases[0].Cws">
                              <option value="1">1.0</option>
                              <option value="0.75">0.75</option>
                              <option value="0.5">0.5</option>
                            </select>
                          </td>
                        </tr>
                        <tr><td colspan="2"><p class="fst-italic comment">Value of wind exposure factor, C<sub>w</sub> applicable to the source of drifting</p></td></tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-6">
                      <!-- <img src="@/assets/images/snow-drift-case 1.png" class="img-fluid about-img" width="150px" /> -->
                    </div>
                  </div>
                </b-tab>
                
                <!-- Case II Tab -->
                <b-tab title="Case II">
                  <table class="table table-sm table-bordered">
                    <tbody>
                      <tr>
                        <td>w<sub>s</sub> (m)</td>
                        <td><input type="number" v-model="cases[1].ws" /></td>
                      </tr>
                      <tr><td colspan="2"><p class="fst-italic comment">Shorter dimension of the upper roof</p></td></tr>
                      <tr>
                        <td>l<sub>s</sub> (m)</td>
                        <td><input type="number" v-model="cases[1].ls" /></td>
                      </tr>
                      <tr><td colspan="2"><p class="fst-italic comment">Longer dimension of the upper roof</p></td></tr>
                      <tr>
                        <td>h<sub>p</sub> (m)</td>
                        <td><input type="number" v-model="cases[1].hp" /></td>
                      </tr>
                      <tr><td colspan="2"><p class="fst-italic comment">Parapet height of the upper roof</p></td></tr>
                      <tr>
                        <td>C<sub>ws</sub></td>
                        <td>
                          <select v-model="cases[1].Cws">
                            <option value="1">1.0</option>
                            <option value="0.75">0.75</option>
                            <option value="0.5">0.5</option>
                          </select>
                        </td>
                      </tr>
                      <tr><td colspan="2"><p class="fst-italic comment">Value of wind exposure factor, C<sub>w</sub> applicable to the source of drifting</p></td></tr>
                    </tbody>
                  </table>
                </b-tab>
                
                <!-- Case III Tab -->
                <b-tab title="Case III">
                  <table class="table table-sm table-bordered">
                    <tbody>
                      <tr>
                        <td>w<sub>s</sub> (m)</td>
                        <td><input type="number" v-model="cases[2].ws" /></td>
                      </tr>
                      <tr><td colspan="2"><p class="fst-italic comment">Shorter dimension of the upper roof</p></td></tr>
                      <tr>
                        <td>l<sub>s</sub> (m)</td>
                        <td><input type="number" v-model="cases[2].ls" /></td>
                      </tr>
                      <tr><td colspan="2"><p class="fst-italic comment">Longer dimension of the upper roof</p></td></tr>
                      <tr>
                        <td>h<sub>p</sub> (m)</td>
                        <td><input type="number" v-model="cases[2].hp" /></td>
                      </tr>
                      <tr><td colspan="2"><p class="fst-italic comment">Parapet height of the upper roof</p></td></tr>
                      <tr>
                        <td>C<sub>ws</sub></td>
                        <td>
                          <select v-model="cases[2].Cws">
                            <option value="1">1.0</option>
                            <option value="0.75">0.75</option>
                            <option value="0.5">0.5</option>
                          </select>
                        </td>
                      </tr>
                      <tr><td colspan="2"><p class="fst-italic comment">Value of wind exposure factor, C<sub>w</sub> applicable to the source of drifting</p></td></tr>
                    </tbody>
                  </table>
                </b-tab>

                <b-tab title="Sliding 4.1.6.11">
                  <div class="row">
                    <div class="col-6">
                      <label for="consider-sliding">Consider Sliding from Upper Roof?</label>
                    </div>
                    <div class="col-6">
                      <select name="consider-sliding" v-model="consider_sliding">
                        <option value=true>Yes</option>
                        <option value=false>No</option>
                      </select>
                    </div>
                  </div>
                  <!-- Upper Roof Pitch -->
                  <div class="row" v-if="consider_sliding">
                    <div class="col-6">
                      <label for="pitch">Upper Roof Pitch:</label>
                    </div>
                    <div class="col-6">
                      <input type="text" name="pitch" v-model="upper_roof_pitch" />/12
                    </div>
                  </div>
                  <!-- Upper Roof Slippery -->
                  <div class="row" v-if="consider_sliding">
                    <div class="col-6">
                      <label for="upper_roof_slippery">Upper roof is slippery?</label>
                    </div>
                    <div class="col-6">
                      <select name="upper_roof_slippery" v-model="upper_roof_slippery">
                        <option value=true>Yes</option>
                        <option value=false>No</option>
                      </select>
                    </div>
                    <p class="fst-italic comment">Snow sliding doesn't need to be considered if the upper roof is not considered slippery and has a slope of less than 20 degrees.</p>
                  </div>
                  <!-- Upper Roof Obstructed -->
                  <div class="row" v-if="consider_sliding">
                    <div class="col-6">
                      <label for="upper_roof_unobstructed">Upper roof is unobstructed?</label>
                    </div>
                    <div class="col-6">
                      <select name="upper_roof_unobstructed" v-model="upper_roof_unobstructed">
                        <option value=true>Yes</option>
                        <option value=false>No</option>
                      </select>
                    </div>
                    <p class="fst-italic comment">Snow sliding doesn't need to be considered if the upper roof is obstructed by a parapet or other effective means.</p>
                  </div>
                </b-tab>
              </b-tabs>
            </div>

      </div>
      <!-- Report Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <h4>Specified Snow Load</h4>
        <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'S = I_s [S_s (C_b C_w C_s C_a) + S_r]'" />
          </div>
          <div class="col-6">
            <p class="fst-italic">
              [4.1.6.2]
            </p>
          </div>
        </div>
        <div>
          <div v-if="climate_method === 'user'">
            <div class="row" v-if="Ss_user">
              <div class="col-6">
                <KaTeXComponent  :expression="'S_s = ' + Ss_user + ' kPa'" />
              </div>
              <div class="col-6">
                <p class="fst-italic">User input</p>
              </div>
            </div>
            <div class="row" v-if="Sr_user">
              <div class="col-6">
                <KaTeXComponent  :expression="'S_r = ' + Sr_user + ' kPa'" />
              </div>
              <div class="col-6">
                <p class="fst-italic">User input</p>
              </div>
            </div>
          </div>
          <div v-if="climate_method === 'location'">
            <div class="row" v-if="Ss_calced">
              <div class="col-6">
                <KaTeXComponent  :expression="'S_s = ' + Ss_calced + ' kPa'" />
              </div>
              <div class="col-6" v-if="province">
                <p class="fst-italic">Province: {{ province }}</p>
              </div>
            </div>
            <div class="row" v-if="Sr_calced">
              <div class="col-6">
                <KaTeXComponent  :expression="'S_r = ' + Sr_calced + ' kPa'" />
              </div>
              <div class="col-6" v-if="city">
                <p class="fst-italic">City: {{ city }}</p>
              </div>
            </div>
          </div>
        </div>

        <hr/>
        <!-- Factors -->
        <h5>Factors:</h5>
        <!-- IS ULS -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'I_s = ' + Is_ULS[Is_category].toFixed(2) + ' (ULS)'" />
          </div>
          <div class="col-6">
            <p class="fst-italic">{{ ["Low", "Normal", "High", "Post-Disaster"][Is_category] }} importance category</p>
          </div>
        </div>
        <!-- IS SLS -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'I_s = ' + Is_SLS[Is_category].toFixed(2) + ' (SLS)'" />
          </div>
          <div class="col-6">
            <p class="fst-italic">{{ ["Low", "Normal", "High", "Post-Disaster"][Is_category] }} importance category</p>
          </div>
        </div>

        <!-- Cw -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'C_w =' + parseFloat(Cw).toFixed(2)" />
          </div>
          <div class="col-6">
            <p class="fst-italic" v-if="parseFloat(Cw) === 0.75">Rural areas</p>
            <p class="fst-italic" v-if="parseFloat(Cw) === 0.5">Exposed areas north of treeline</p>
          </div>
        </div>

        <!-- Cb -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent v-if="l & w" :expression="'C_b =' + parseFloat(Cb_calced).toFixed(2)" />
            <KaTeXComponent v-else :expression="'C_b =' + parseFloat(Cb_user).toFixed(2)" />
          </div>
          <div class="col-6">
            <p class="fst-italic" v-if="l && w">Based on characteristic length l<sub>c</sub> of {{  this.lc.toFixed(2) }}m</p>
            <p class="fst-italic" v-else>Based on user input</p>
          </div>
        </div>
        <!-- Cs -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent v-if="Cs_method === 'user'" :expression="'C_s =' + parseFloat(Cs_user).toFixed(2)" />
            <KaTeXComponent v-else :expression="'C_s =' + parseFloat(Cs_calced).toFixed(2)" />
          </div>
          <div class="col-6">
            <p class="fst-italic" v-if="Cs_method === 'user'">Based on user input</p>
            <p class="fst-italic" v-else>Based on roof slope = {{ slope.toFixed(2) }} degrees, non-slippery roof</p>
          </div>
        </div>
        <!-- Ca -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent v-if="Ca_method === 'user'" :expression="'C_a =' + parseFloat(Ca_user).toFixed(2)" />
            <KaTeXComponent v-else :expression="'C_a =' + parseFloat(Ca_calced).toFixed(2)" />
          </div>
          <div class="col-6">
            <p class="fst-italic" v-if="Ca_method === 'user'">Based on user input</p>
            <p class="fst-italic" v-else>Multi-level Roofs [4.1.6.5]</p>
          </div>
        </div>
        <hr />

        <!-- Snow Loads -->
        <div class="row" v-if="S_uniform.ULS && S_uniform.SLS">
          <div class="col-12">
            <h4>Uniform Snow Load</h4>
          </div>
          <div class="col-6">
            <!-- <KaTeXComponent :expression="'C_w = 1'" />
            <KaTeXComponent :expression="'C_a = 1'" /> -->
            <KaTeXComponent :expression="'S_{SLS} = ' + S_uniform.SLS.toFixed(2) + ' kPa'" />
            <!-- <KaTeXComponent :expression="'C_w = 1'" />
            <KaTeXComponent :expression="'C_a = 1'" /> -->
            <KaTeXComponent :expression="'S_{ULS} = ' + S_uniform.ULS.toFixed(2) + ' kPa'" />
          </div>
          <div class="col-6">
            <Visualizer :descriptor="uniformSnowLoadDescriptor" :width="300" :height="80" />
          </div>
        </div>
        <div class="row " v-if="Ca_method === 'multi_level_roofs' && S_drift.ULS && S_drift.SLS">
          <div class="col-12 mt-3">
            <h4>Drift Snow Load</h4>
          </div>
          <div class="col-6">
            <!-- <KaTeXComponent :expression="'C_{a0} = ' + Ca0_max.toFixed(2)" /> -->
            <!-- <KaTeXComponent :expression="'C_w = 1'" />
            <KaTeXComponent :expression="'C_a = 1'" /> -->
            <KaTeXComponent :expression="'S_{SLS} = ' + S_drift.SLS.toFixed(2) + ' kPa'" />
            <!-- <KaTeXComponent :expression="'C_w = 1'" />
            <KaTeXComponent :expression="'C_a = 1'" /> -->
            <KaTeXComponent :expression="'S_{ULS} = ' + S_drift.ULS.toFixed(2) + ' kPa'" />
            <KaTeXComponent :expression="'x_d = ' + xd_max.toFixed(2) + ' m'" />
          </div>
          <div class="col-6">
            <Visualizer :descriptor="driftSnowLoadDescriptor" :width="300" :height="80" />
          </div>
          <div class="row" v-if="consider_sliding">
            <div class="col-12 mt-3">
              <h4>Sliding Snow Load</h4>
            </div>
            <div class="col-6">
              <!-- <KaTeXComponent :expression="'C_w = 1'" />
              <KaTeXComponent :expression="'C_a = 1'" /> -->
              <KaTeXComponent :expression="'S_{SLS} = ' + S_sliding.SLS.toFixed(2) + ' kPa'" />
              <!-- <KaTeXComponent :expression="'C_w = 1'" />
              <KaTeXComponent :expression="'C_a = 1'" /> -->
              <KaTeXComponent :expression="'S_{ULS} = ' + S_sliding.ULS.toFixed(2) + ' kPa'" />
            </div>
            <div class="col-6">
              <Visualizer  v-if="S_sliding.ULS > 0" :descriptor="slidingSnowLoadDescriptor" :width="300" :height="80" />
            </div>
          </div>
          <div class="col-12 mt-3">
            <h4>Total Snow Load</h4>
          </div>
          <div class="col-6">
            <!-- <KaTeXComponent :expression="'C_{a0} = ' + Ca0_max.toFixed(2)" /> -->
            <!-- <KaTeXComponent :expression="'C_w = 1'" />
            <KaTeXComponent :expression="'C_a = 1'" /> -->
            <KaTeXComponent :expression="'S_{SLS} = ' + (S_uniform.SLS + S_drift.SLS + S_sliding.SLS).toFixed(2) + ' kPa'" />
            <!-- <KaTeXComponent :expression="'C_w = 1'" />
            <KaTeXComponent :expression="'C_a = 1'" /> -->
            <KaTeXComponent :expression="'S_{ULS} = ' + (S_uniform.ULS + S_drift.ULS + S_sliding.ULS).toFixed(2) + ' kPa'" />
            <KaTeXComponent :expression="'x_d = ' + xd_max.toFixed(2) + ' m'" />
          </div>
          <div class="col-6">
            <Visualizer :descriptor="totalSnowLoadDescriptor" :width="300" :height="100" />
          </div>
        </div>
        <hr/>

        <!-- Ca0 Cases -->
        <div v-if="Ca_method === 'multi_level_roofs'">
          <h5>Snow Drift Calculation</h5>
          
          <!-- Specific weight of snow -->
          <div class="row">
            <div class="col-6">
              <KaTeXComponent :expression="'\\gamma = ' + gamma.toFixed(2) + ' \\text{ kN/m}^3'" />
            </div>
            <div class="col-6">
              <p class="fst-italic">Specific weight of snow (min 4.0 or 0.43S<sub>s</sub>+2.2)</p>
            </div>
          </div>
          <div class="px-2" v-for="caseData in Ca0_cases" :key="caseData.caseNumber">
            <hr />
            <h6>Case {{ ['I', 'II', 'III'][caseData.caseNumber - 1] }}</h6>
            
            <!-- Input parameters -->
            <!-- <div class="row">
              <div class="col-6">
                <KaTeXComponent :expression="'w_s = ' + caseData.ws.toFixed(2) + ' \\text{ m}'" />
              </div>
              <div class="col-6">
                <p class="fst-italic">Width of source area</p>
              </div>
            </div>
            
            <div class="row">
              <div class="col-6">
                <KaTeXComponent :expression="'l_s = ' + caseData.ls.toFixed(2) + ' \\text{ m}'" />
              </div>
              <div class="col-6">
                <p class="fst-italic">Length of source area</p>
              </div>
            </div>
            
            <div class="row">
              <div class="col-6">
                <KaTeXComponent :expression="'h_p = ' + caseData.hp.toFixed(2) + ' \\text{ m}'" />
              </div>
              <div class="col-6">
                <p class="fst-italic">Parapet height</p>
              </div>
            </div> -->
            
            <!-- <div class="row">
              <div class="col-6">
                <KaTeXComponent :expression="'C_{ws} = ' + caseData.Cws.toFixed(2)" />
              </div>
              <div class="col-6">
                <p class="fst-italic">Wind exposure factor for source area</p>
              </div>
            </div> -->
            
            <!-- Characteristic length -->
            <div class="row">
              <div class="col-6">
                <KaTeXComponent :expression="'l_{cs} = 2w_s - \\frac{w_s^2}{l_s} = ' + caseData.lcs.toFixed(2) + ' \\text{ m}'" />
              </div>
              <div class="col-6">
                <p class="fst-italic">Characteristic length of source area</p>
              </div>
            </div>
            
            <!-- h'p -->
            <div class="row">
              <div class="col-6">
                <KaTeXComponent :expression="'h\'_p = \\max\\left(0, h_p - 0.8\\frac{S_sC_{ws}}{\\gamma}\\right) = ' + caseData.hp_prime.toFixed(2) + ' \\text{ m}'" />
              </div>
              <div class="col-6">
                <p class="fst-italic">Effective parapet height (limited to l<sub>cs</sub>/5)</p>
              </div>
            </div>
            
            <!-- F -->
            <div class="row">
              <div class="col-6">
                <KaTeXComponent :expression="'F = 0.35\\beta\\sqrt{\\frac{\\gamma(l_{cs} - 5h\'_p)}{S_s}} + C_b = ' + caseData.F.toFixed(2)" />
              </div>
              <div class="col-6">
                <p class="fst-italic">Drift factor (limited to 5.0 when C<sub>ws</sub> = 1.0)</p>
              </div>
            </div>
            
            <!-- Ca0 -->
            <div class="row">
              <div class="col-6">
                <KaTeXComponent :expression="'C_{a0} = \\min(\\frac{\\beta\\gamma h}{C_bS_s}, \\frac{F}{C_b}) = ' + caseData.Ca0.toFixed(2)" />
              </div>
              <div class="col-6">
                <p class="fst-italic">Accumulation factor for Case {{ ['I', 'II', 'III'][caseData.caseNumber - 1] }}</p>
              </div>
            </div>

            <!-- xd -->
            <div class="row">
              <div class="col-6">
                <KaTeXComponent :expression="'x_{d} = 5\\frac{C_bS_s}{\\gamma}(C_a0 - 1) = ' + caseData.xd.toFixed(2) + 'm'" />
              </div>
              <div class="col-6">
                <p class="fst-italic">Accumulation factor for Case {{ ['I', 'II', 'III'][caseData.caseNumber - 1] }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row mt-1">
          <div class="col-6">
            <h5>Load Case II</h5>
          </div>
          <div class="col-6">
            <p class="fst-italic" v-if="this.slope < 15">
              Load Case II does not apply to gable roofs with slopes of 15 degrees or
              less.
            </p>
          </div>
        </div> -->
        <!-- <SnowDriftVisualizer /> -->
      </div>
    </div>
  </div>
</template>

<!-- Script -->
<script>
  import TopbarNav from "@/components/TopbarNav.vue";
  import Visualizer from '@/components/Visualizer.vue';
  // import SnowDriftVisualizer from './components/SnowDriftVisualizer.vue';

  import database from '@/assets/database.json';

  export default {
    name: "SnowLoad",
    components: { 
      TopbarNav, 
      Visualizer
      // SnowDriftVisualizer
    },
    data: function () {
      return {
        climate_method: "location", // Whether Ss or Sr are defined by user or by location
        province: "Ontario",
        city: "Toronto Metropolitan Region - Toronto (City Hall)",
        Ss_user: 0.9,
        Sr_user: 0.4,
        Is_category: 1,
        Is_ULS: [0.75, 1, 1.25, 1.5],
        Is_SLS: [0.8, 0.8, 0.8, 0.8],
        Cb_method: "user", // Whether Cb will be defined by user or should be calculated based on roof plan dimensions
        Cb_user: 0.8,
        Cs_method: "user", // Whether Cs will be defined by user or should be calculated based on roof pitch
        Cs_user: 1,
        Ca_method: "user", // Whether Ca will be defined by user or should be calculated based on roof geometry
        Ca_user: 1,
        Cw: 1,
        // Ca: 1,
        pitch: 0,
        slippery: false,
        l: 10,
        w: 10,
        h: 3, // Height difference for Ca calculation
        a: 0, // Horizontal gap for Ca calculation
        cases: [
          { ws: 10, ls: 10, hp: 0, Cws: "1", beta: 1.00 }, // Case I
          { ws: 10, ls: 10, hp: 0, Cws: "1", beta: 0.67 }, // Case II
          { ws: 10, ls: 10, hp: 0, Cws: "1", beta: 0.67 }  // Case III
        ],
        consider_sliding: false,
        upper_roof_pitch: 0,
        upper_roof_slippery: false,
        upper_roof_unobstructed: false,
      };
    },
    computed: {
      cities: function() {
        return database.filter(item => item.province === this.province);
      },
      Ss_calced: function() {
        return this.city ? this.cities.filter(city => city.city === this.city)[0]["Ss (kPa)"] : undefined;
      },
      Sr_calced: function() {
        return this.city ? this.cities.filter(city => city.city === this.city)[0]["Sr (kPa)"] : undefined;
      },
      slope: function() {
        return (Math.atan(this.pitch/12)*(180/Math.PI));
      },
      upper_roof_slope: function() {
        return (Math.atan(this.upper_roof_pitch/12)*(180/Math.PI));
      },
      Cs_calced: function() {
        if (this.slippery) {
          if(this.slope <= 15) {
            return 1;
          } else if (this.slope > 15 && this.slope <= 60) {
            return (60-this.slope)/45;
          } else {
            return 0
          }
        } else {
          if(this.slope <= 30) {
            return 1;
          } else if (this.slope > 30 && this.slope <= 70) {
            return (70-this.slope)/40;
          } else {
            return 0
          }
        }      
      },
      lc: function() {
        return 2*this.w - this.w*this.w / this.l;
      },
      Cb_calced: function() {
        if(this.lc <= (70/Math.pow(this.Cw, 2))) {
          return 0.8;
        } else {
          const exponent = -1*(this.lc * Math.pow(this.Cw, 2) - 70) / 100;
          return (1 / this.Cw) * (1 - (1 - 0.8 * this.Cw) * Math.exp(exponent));
        }
      },
      Ca_calced: function() {
        // Placeholder for Ca calculation based on roof geometry
        return this.Ca0_max; // Default value, replace with actual calculation if needed
      },
      Sr: function() {
        return this.climate_method === 'user' ? parseFloat(this.Sr_user) : parseFloat(this.Sr_calced);
      },
      Ss: function() {
        return this.climate_method === 'user' ? parseFloat(this.Ss_user) : parseFloat(this.Ss_calced);
      },
      S_uniform: function() {
        const Is_SLS = this.Is_SLS[this.Is_category];
        const Is_ULS = this.Is_ULS[this.Is_category];
        const Cb = this.Cb_user || this.Cb_calced;
        const Cs = this.Cs_user || this.Cs_calced;
        const Cw = this.Cw;
        const Ca = 1; // Uniform load assumes Ca = 1
        // const Ca = this.Ca_user || this.Ca_calced;
        const Sr = this.Sr;
        const Ss = this.Ss;
        // console.log(
        //   Is_SLS, Is_ULS, Cb, Cs, Cw, Ca, Sr, Ss
        // ); # Debug

        return {
          "SLS": Is_SLS*(Ss*(Cb*Cs*Cw*Ca) + Sr),
          "ULS": Is_ULS*(Ss*(Cb*Cs*Cw*Ca) + Sr)
        }
      },
      S_drift: function() {
        const Is_SLS = this.Is_SLS[this.Is_category];
        const Is_ULS = this.Is_ULS[this.Is_category];
        const Cb = this.Cb_user || this.Cb_calced;
        const Cs = this.Cs_user || this.Cs_calced;
        const Cw = this.Cw;
        const Ca = (this.Ca_calced || 1) - 1; // Drift load uses Ca - 1
        const Sr = this.Sr;
        const Ss = this.Ss;

        return {
          "SLS": Is_SLS*(Ss*(Cb*Cs*Cw*Ca) + Sr),
          "ULS": Is_ULS*(Ss*(Cb*Cs*Cw*Ca) + Sr)
        }
      },
      S_sliding: function() {
        const Is_SLS = this.Is_SLS[this.Is_category];
        const Is_ULS = this.Is_ULS[this.Is_category];
        const Cb = 0.8; // SHould this be 1? or 0.8?
        const Cs = this.Cs_user || this.Cs_calced;
        const Cw = 1;
        const Ca = 1
        const Sr = this.Sr;
        const Ss = this.Ss;
        // 4.1.6.11
        if ((this.upper_roof_slope < 20 && !this.upper_roof_slippery) || !this.upper_roof_unobstructed) {
          return {
            "SLS": 0,
            "ULS": 0
          };
        } else {
          return {
            "SLS": 0.5 * Is_SLS*(Ss*(Cb*Cs*Cw*Ca) + Sr),   
            "ULS": 0.5 * Is_ULS*(Ss*(Cb*Cs*Cw*Ca) + Sr)   
          }
        }
      },
      gamma: function() {
        return Math.min(4, 0.43 * this.Ss + 2.2); // kN/m3 4.1.6.13 Speicifc weight of snow 
      },
      Ca0_cases: function() {
        if (this.Ca_method !== 'multi_level_roofs') return [];
        
        return this.cases.map((caseData, index) => {
          if (!caseData.ws || !caseData.ls) return null;
          
          const gamma = this.gamma;
          const h = this.h;
          const Ss = this.Ss;
          const beta = caseData.beta;
          const ws = caseData.ws;
          const ls = caseData.ls;
          const hp = caseData.hp;
          const Cb = this.Cb_user || this.Cb_calced;
          const Cws = parseFloat(caseData.Cws);
          // Calculate lcs for this case
          const lcs = 2 * ws - (ws * ws) / ls;
          
          // Calculate h'p for this case
          let hp_prime = Math.max(0, parseFloat(hp) - 0.8 * (Ss * Cws) / gamma);
          hp_prime = Math.min(hp_prime, lcs / 5); // h'p should not exceed lcs/5

          // Calculate F for this case
          let F = 0.35 * beta * Math.sqrt((gamma * (lcs - 5*hp_prime)) / Ss) + Cb;
          if (Cws === 1.0) F = Math.min(F, 5.0);
          
          // Calculate Ca0 using two formulas and take minimum
          const Ca0_formula1 = beta * gamma * h / (Cb * Ss);
          const Ca0_formula2 = F / Cb;
          const Ca0 = Math.min(Ca0_formula1, Ca0_formula2);
          const xd = 5 * Cb * Ss * (Ca0 - 1) / gamma; // Drift length
          
          return {
            caseNumber: index + 1,
            ws: caseData.ws,
            ls: caseData.ls,
            hp: caseData.hp,
            Cws: parseFloat(caseData.Cws),
            lcs: lcs,
            hp_prime: hp_prime,
            F: F,
            Ca0: Ca0,
            xd: xd
          };
        }).filter(c => c !== null);
      },
      Ca0_max: function() {
        if (this.Ca_method !== 'multi_level_roofs' || this.Ca0_cases.length === 0) {
          return null;
        }
        
        const maxCase = this.Ca0_cases.reduce((max, current) => {
          return current.Ca0 > max.Ca0 ? current : max;
        });
        
        // Horizontal gap larger than 5m trigger 4.1.6.6.
        if (this.a >5) return 1;

        return maxCase.Ca0;
      },
      xd_max: function() {
        if (this.Ca_method !== 'multi_level_roofs' || this.Ca0_cases.length === 0) {
          return null;
        }
        
        const maxCase = this.Ca0_cases.reduce((max, current) => {
          return current.Ca0 > max.Ca0 ? current : max;
        });
        
        return maxCase.xd;
      },
      uniformSnowLoadDescriptor: function() {
        return  [
          {
            type: "distributedForce",
            points: [{ x: 50, y: 60 }, { x: 200, y: 60 }],
            heights: [20, 20],
            texts: {left: "", center: this.S_uniform.ULS + " kPa", right: ""},
            numForceLines: 6
          }
        ]
      },
      driftSnowLoadDescriptor: function() {
        return  [
          {
            type: "distributedForce",
            points: [{ x: 50, y: 60 }, { x: 150, y: 60 }],
            heights: [20, 0],
            texts: {left: this.S_drift.ULS.toFixed(2) + " kPa", center: "", right: ""},
            numForceLines: 6
          },
          {
            type: "line",
            points: [
              { x: 50, y: 40 },
              { x: 150, y: 40 }
            ],
            markerStart: "url(#arrow)",
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "text",
            text: this.xd_max.toFixed(2) + " m",
            x: 80,
            y: 52
          },
        ]
      },
      slidingSnowLoadDescriptor: function() {
        return  [
          {
            type: "distributedForce",
            points: [{ x: 50, y: 60 }, { x: 150, y: 60 }],
            heights: [10, 0],
            texts: {left: this.S_sliding.ULS.toFixed(2) + " kPa", center: "", right: ""},
            numForceLines: 4
          },
          {
            type: "line",
            points: [
              { x: 50, y: 40 },
              { x: 150, y: 40 }
            ],
            markerStart: "url(#arrow)",
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "text",
            text: this.xd_max.toFixed(2) + " m",
            x: 80,
            y: 52
          },
        ]
      },
      totalSnowLoadDescriptor: function() {
        return [
          {
            type: "line",
            points: [
              { x: 50, y: 70 },
              { x: 200, y: 70 }
            ],
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 50, y: 10 },
              { x: 150, y: 40 }
            ],
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 150, y: 40 },
              { x: 200, y: 40 }
            ],
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 50, y: 10 },
              { x: 50, y: 70 }
            ],
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 75, y: 17.5 },
              { x: 75, y: 70 }
            ],
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 100, y: 25 },
              { x: 100, y: 70 }
            ],
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 125, y: 32.5 },
              { x: 125, y: 70 }
            ],
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 150, y: 40 },
              { x: 150, y: 70 }
            ],
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 175, y: 40 },
              { x: 175, y: 70 }
            ],
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 200, y: 40 },
              { x: 200, y: 70 }
            ],
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "line",
            points: [
              { x: 50, y: 75 },
              { x: 150, y: 75 }
            ],
            markerStart: "url(#arrow)",
            markerEnd: "url(#arrow)",
            strokeWidth: 0.5,
          },
          {
            type: "text",
            text: this.xd_max.toFixed(2) + " m",
            x: 80,
            y: 85,
          },
        ]
      }
    },
    watch: {
      province: function(newProvince) {
        if (newProvince && this.cities.length > 0) {
          this.city = this.cities[0].city;
        }
      }
    }
  };
</script>

<style scoped>

</style>
